import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { DomSanitizer,SafeHtml} from '@angular/platform-browser';

export interface  dialogData{
  title?:string,
  paragraphs:string[],
  showYes?:boolean,
  showNo?:boolean,
  textYes?:string,
  textNo?:string
}

@Component({
  selector: 'app-modal-confirm',
  templateUrl: './modal-confirm.component.html',
  styleUrls: ['./modal-confirm.component.scss']
})
export class ModalConfirmComponent  {

  constructor(
    public dialogRef: MatDialogRef<ModalConfirmComponent>,
    @Inject(MAT_DIALOG_DATA) public data: dialogData
  ) { 
    data.showNo = data.showNo==null ? true : data.showNo;
    data.showYes = data.showYes==null ? true : data.showYes;
  }

  close() {
    this.dialogRef.close(false);
  }

}
